import Abril from 'products/global/assets/img/join-us/people/Abril.jpg';
import Adrian from 'products/global/assets/img/join-us/people/Adrian.jpg';
import Libby from 'products/global/assets/img/join-us/people/Libby.png';
import Emmi from 'products/global/assets/img/join-us/people/Emmi.jpg';

export const CARDS = [
  {
    type: 'video',
    id: 1,
    name: 'Libby',
    video: 'https://storage.googleapis.com/safetywing-static/videos/Libby.mp4',
    photo: Libby,
    location: 'Whitefish, USA'
  },
  {
    type: 'video',
    id: 2,
    name: 'Abril',
    video: 'https://storage.googleapis.com/safetywing-static/videos/Abril.mp4',
    photo: Abril,
    location: 'Andorra'
  },
  {
    id: 3,
    name: 'Adrian',
    photo: Adrian,
    location: 'Lima, Peru',
    description:
      '"I always dreamt about working with people that are high in intellect and kindness at the same time, and that’s precisely what I get to experience in SafetyWing.The fantastic team plus a remarkable life/work balance culture, extremely high autonomy, and most importantly, a mission worth doing makes me happy and excited about the present and the future."'
  },
  {
    id: 4,
    name: 'Emmi',
    photo: Emmi,
    location: 'Helsinki, Finland',
    description:
      '"What first drew me to work at SafetyWing was the freedom to choose when and where I work. I no longer spend my workdays waiting for short vacations - instead my everyday life lately consists of scuba diving in Indonesia, road trips in the US, and hiking in Madeira. What’s made me stay, though, is the possibility to work with inspiring people to co-create something beautiful, in keeping with the mission to make the world a more equal place."'
  }
];
